import React from 'react';

const VerifyPage = () => {
  return <div>Please verify using the email sent to your email address</div>;
};

export {VerifyPage};
